// todo: create a global deals-list component
// for now we use this an empty component to hold the css
// todo: move the css to AEM if a global component is not needed or at least
// understand that css for this component lives here while the html and js lives in AEM
import React from 'react';

const DealsList = () => <div />;

export default DealsList;
